import React from "react";
import styled, { css } from "styled-components";
import { rem, transparentize } from "polished";
import Button from "../../../Button";
import clsx from "clsx";

const ListItem = ({
  data,
  onHandleSet,
  onModalClose,
  setSingleData = false,
  selectedKey = "",
  onSetDetailModal,
  setSelectedItem,
  selectedItem ={}
}) => {
  if (!data) return void 0;

  const handleSetData = (data) => {
    if (!setSingleData && selectedKey === "") onHandleSet(data);
    else {
      let items = {};
      items[selectedKey] = data;
      onHandleSet(items);
    }
    onModalClose();
  };


  return (
    <ListItemLayout style={{ borderTop: "30px solid transparent" }}>
      {data.map((option, i) => {
        const { label, desc, image, price, unit,ptype,content,dimension ,maxtjocklek,mintjocklek,skapstorlek, id} = option;

        return (
          <div className="item" key={i} data-selected={id !== undefined && selectedItem.id !== undefined && Boolean(id === selectedItem?.id)}>
            {/* <div className="item-title">
              <h6 dangerouslySetInnerHTML={{ __html: label || desc }} />
              <span>{[price, unit].join(" ")}</span>
            </div> */}
            <div className="item-content">
              <div className="icon-info" 
                        onClick={() => {
                          setSelectedItem?.(option);
                          onSetDetailModal?.(true);
                        }}
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="50" height="50" viewBox="0 0 32 32">
                          <path d="M 16 3 C 8.832031 3 3 8.832031 3 16 C 3 23.167969 8.832031 29 16 29 C 23.167969 29 29 23.167969 29 16 C 29 8.832031 23.167969 3 16 3 Z M 16 5 C 22.085938 5 27 9.914063 27 16 C 27 22.085938 22.085938 27 16 27 C 9.914063 27 5 22.085938 5 16 C 5 9.914063 9.914063 5 16 5 Z M 15 10 L 15 12 L 17 12 L 17 10 Z M 15 14 L 15 22 L 17 22 L 17 14 Z"></path>
                        </svg>
                      </div>

              <div className="texture-details"  onClick={() => handleSetData(option)}>
                      
                      <div className="image">
                        <img src={image} alt={label} className={clsx({
                        circular: ptype === 'product'
                      })}/>
                      </div>
                       <>
                        <div className="title">
                          <h2>{label}</h2>
                        </div>
                        <div className="details">
                          {dimension && dimension.length ? (
                            <p>
                              Dimensioner:
                              {dimension.join(" X ")} mm
                            </p>
                          ) : null}
                          <p className="price">Pris: {[price, unit].join(" ")}</p>
                          {maxtjocklek ? <p>Max tjocklek: {maxtjocklek}</p> : null}
                          {mintjocklek ? <p>Min tjocklek: {mintjocklek}</p> : null}
                          {skapstorlek ? <p>Skåpstorlek: {skapstorlek} mm</p> : null}
                        </div>
                      </>
                      
                     
                    </div>
              {/* <div
                className="item-image"
                onClick={() => {
                  setSelectedItem?.(option);
                  onSetDetailModal?.(true);
                }}
              >
                <img src={image} alt={label || desc} />
              </div>
              <div className="button-wrapper">
                <Button onClick={() => handleSetData(option)}>VÄLJ</Button>
              </div> */}
            </div>
          </div>
        );
      })}
    </ListItemLayout>
  );
};
export default ListItem;

const ListItemLayout = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-wrap: wrap;
    row-gap: 30px;
    max-width: 70%;
    margin: 0 auto;
    gap: 15px;

    @media (max-width: 1366px) {
      max-width: 100%;
    }

  
    .item {
      flex: 0 0 calc(20% - 15px);
      max-width: calc(20% - 15px);
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
      background-color:  ${theme.colors.white};
      padding: 60px 20px;
      border-radius: 30px;
      border: 4px solid transparent;
      transition: 0.3s ease all;

        @media (max-width: 1680px) {
     flex: 0 0 calc(25% - 15px);
      max-width: calc(25% - 15px);
    }

     @media (max-width: 991px) {
      flex: 0 0 calc(33.333% - 15px);
      max-width: calc(33.333% - 15px);
      }

      @media (max-width: 767px) {
        flex: 0 0 calc(50% - 15px);
      max-width: calc(50% - 15px);
      }

      @media (max-width: 480px) {
       flex: 0 0 100%;
      max-width: 100%;
      }


      &:hover, &[data-selected="true"] {
        border-color:${theme.colors.primary};
      }
      

      .item-title {
        display: flex;
        justify-content: space-between;
        margin-bottom: ${rem(20)};

        h6 {
          font-size: ${rem(14)};
          margin: 0;
          text-transform: capitalize;
        }

        span {
          font-size: ${rem(12)};
          color: ${theme.colors.primary};
          flex-grow: 1;
          white-space: nowrap;
          text-align: right;
          margin-left: ${rem(10)};
        }
      }

      .item-content {
        /* margin-top: auto; */
        text-align: center;
        position: relative;

          .icon-info {
            position: absolute;
            top: -50px;
            left: -10px;
            width: 30px;
            height: 30px;
            z-index: 2;

            svg {
              width: 100%;
              height: 100%;
            }
          }

        .texture-details {
          

          .title {
            h2 {
              font-size: ${rem(22)};
                font-weight: normal;
                line-height: normal;
                word-break: break-all;
            }
            margin-bottom: 10px;
          }
          .details {
            p {
              &.price {
                font-size: 18px;
                font-weight: bold;
                color: ${theme.colors.primary};
              }

              + p {
                margin-top: ${rem(10)};
              }
            }
          }
          .image {
            margin-bottom: 20px;
            
            img {
             max-width: 80%;
             
             &:not(.circular) {
              height: 100px;
              object-fit: contain;
             }

              &.circular {
                border-radius: 50%;
                max-width: 100%;
                width: 100px;
                height: 100px;
                object-fit: cover;
              }
            }
          }
        }

        .item-image {
          text-align: center; 
          position: relative;
        }
        .button-wrapper {
          margin-top: ${rem(20)};
          button {
            width: 100%;
            background-color: ${transparentize(0.91, theme.colors.black)};
            border: none;
            padding: 15px 0;
            cursor: pointer;
            position: relative;
            color: #000;
            overflow: hidden;
            transition: 0.3s ease all;

            &::after {
              content: "";
              position: absolute;
              width: 100%;
              height: 100%;
              background-color: ${theme.colors.primary};
              top: 0;
              left: 0;
              pointer-events: none;
              z-index: -1;
              transform: translateX(calc(100% - 22px)) skewX(-45deg);
              transition: 0.3s ease all;
            }

            &:hover {
              color: ${theme.colors.white};
              &::after {
                transform: translateX(22px) skewX(-45deg);
              }
            }
          }
        }
      }
    }
  `}
`;
